'use client';

import { createParser } from 'nuqs';
import { MEETING_ASIDE_KEY, MEETING_ASIDE_SLUG, SUCCESS_STEP_KEY, SUCCESS_STEP_SLUG } from '../stepKeys';
import { StepDefinition } from './makeManifest';

/**
 * Creates a nuqs parser that maps step slugs in the URL to step _keys in state.
 * - parse(slug) → _key (for internal state)
 * - serialize(_key) → slug (for URL)
 *
 * In addition to manifest steps, this parser round-trips the success and
 * meeting-aside pseudo-steps (`?s=success`, `?s=book-meeting`).
 *
 * @param steps - Current steps (parser closes over this; create a new parser when steps change)
 */
export function createStepKeyParser(steps: StepDefinition[]) {
  return createParser({
    parse(queryValue: string): string | null {
      if (queryValue === SUCCESS_STEP_SLUG) return SUCCESS_STEP_KEY;
      if (queryValue === MEETING_ASIDE_SLUG) return MEETING_ASIDE_KEY;
      const step = steps.find(s => s.slug === queryValue);
      if (step) return step._key;
      // Backward compatibility: URL may still contain legacy _key
      const byKey = steps.find(s => s._key === queryValue);
      return byKey ? byKey._key : null;
    },
    serialize(value: string): string {
      if (value === SUCCESS_STEP_KEY) return SUCCESS_STEP_SLUG;
      if (value === MEETING_ASIDE_KEY) return MEETING_ASIDE_SLUG;
      const step = steps.find(s => s._key === value);
      return step ? step.slug : value;
    }
  });
}